<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-select
          :items="listDesigner"
          :item-text="(obj) => obj.name"
          :item-value="(obj) => obj.username"
          label="Designer"
          dense
          outlined
          v-model="designer_username"
        ></v-select>
      </v-col>

      <v-col cols="12"> Tasks Selected: {{ listTasks.length }} </v-col>

      <v-col cols="12">
        <v-btn color="success" @click="assignDesigner" v-if="designer_username"
          >Assign Designer</v-btn
        >
        <v-btn color="success" v-else disabled>Assign Designer</v-btn>
        &nbsp;

        <v-btn class="white--text" color="warning" @click="cancelData">
          Cancel <v-icon right dark>mdi-window-close</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
//import axios from "axios"
//import Vue from "vue";
//import HTTP from "../http-common"
import Amplify, { Auth } from "aws-amplify";

Amplify.configure({
  Auth: {
    region: "ap-southeast-1",
    userPoolId: "ap-southeast-1_8vBdk5PAd",
    userPoolWebClientId: "51e572vhkn38k7tuvsdst697b1",
    mandatorySignIn: true,
  },
});

export default {
  name: "AssignDesigner",

  props: {
    listTasks: Array,
    listDesigner: Array,
  },

  data: () => ({
    userId: "",
    AuthStr: "", //'Bearer '.concat(this.$cookies.get('token')),
    designer_username: "",
    listTaskIds: [],
  }),

  methods: {
    loadData() {
      console.log("loadData");
      for (const i of this.listTasks) {
        this.listTaskIds.push(i._id);
      }
    },

    async assignDesigner() {
      var item = {
        assigner_username: this.userId,
        designer_username: this.designer_username,
        task_ids: this.listTaskIds,
      };

      var currentSession = await this.$root.$refs.App.currentSession(
        "task-assign"
      );
      //console.log('currentSession: ',currentSession.accessToken)
      if (currentSession.accessToken) {
        await fetch(window.domain + "tasks/assign-designer", {
          method: "POST",
          headers: { Authorization: currentSession.accessToken },
          body: JSON.stringify(item),
        })
          .then((response) => response.json())
          .then((data) => console.log(data));
        this.$root.$refs.task.showAlert(
          "assign",
          this.designer_username,
          this.listTaskIds
        );
      } else {
        console.log("currentSession task-assign-undefined: ", currentSession);
      }
    },

    cancelData() {
      this.$root.$refs.task.turnOffDialog();
    },
  },

  async mounted() {
    console.log(this.listTasks);
    console.log(this.listDesigner);

    try {
      await Auth.currentAuthenticatedUser({ bypassCache: false });
      var currentSession;
      try {
        currentSession = await Auth.currentSession(); // Auth.currentSession() will automatically refresh the accessToken and idToken if tokens are expired
        console.log("task-assigned currentSession: ", currentSession);
      } catch (error) {
        console.log("task-assigned error: ", error);
      }

      if (currentSession != undefined) {
        this.userId = currentSession.accessToken.payload.username;
        //currentSession.accessToken.jwtToken;
      }
      this.loadData();
    } catch (error) {
      console.log("User logged out!");
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
</style>